import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Campo } from '../interfaces/utilidades/campo.interface';
import { CrudService} from './crud-service';

@Injectable({
  providedIn: 'root'
})
export class CampoService extends CrudService<Campo> {
  constructor(http: HttpClient) {
    super(http, 'https://camposdeportivos.muninuevochimbote.gob.pe/api/campo');
  }
}
